"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FullWidthButtonGroup = (0, _styledComponents.default)(_UIButtonGroup.default).withConfig({
  displayName: "CalculatorButtonGroup__FullWidthButtonGroup",
  componentId: "qx7hsl-0"
})(_templateObject());

var CalculatorButtonGroup = function CalculatorButtonGroup(_ref) {
  var children = _ref.children;
  return _react.default.createElement(FullWidthButtonGroup, {
    className: "m-top-3"
  }, children);
};

var _default = CalculatorButtonGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CalculatorButtonGroup.js
// module id = 803
// module chunks = 5 6